import React from 'react';
import PageHeading from '@components/PageHeading';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface TitleProps {
  plainTitle: string;
  highlightedTitle: string;
}

const Title = (props: TitleProps) => {
  const { plainTitle, highlightedTitle } = props;
  return (
    <h2
      className={ivclass(
        'iv-text-grey-85',
        'iv-text-center',
        'iv-m-heading-2xs md:iv-m-heading-2xl lg:iv-m-heading-2xl xl:iv-m-heading-4xl',
        'iv-text-heading-2xs md:iv-text-heading-2xl lg:iv-text-heading-2xl xl:iv-text-heading-4xl',
        'iv-font-extrabold',
      )}
    >
      <span>{plainTitle}</span>
      <span
        className={ivclass(
          'iv-inline-block',
          'iv-bg-clip-text iv-text-transparent',
          'iv-text-gradient-green',
        )}
      >
        {highlightedTitle}
      </span>
    </h2>
  );
};

export default Title;
